import { useState } from "react";

const viewSizeConfig = {
  small: {
    container: {
      p: 1,
      borderRadius: 2,
      backgroundColor: "#F9F6EE", // cream light
      color: "#212121", // Almost-black text
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 2,
      minHeight: 48,

      width: "99%",
      borderBottom: "1px solid #E3E7ED", // Modern light gray
      position: "relative",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.4)",
      transition: "background 0.2s, box-shadow 0.2s",
      "&:hover": { backgroundColor: "#EEF1F4" },
    },
    image: {
      width: 32,
      height: 32,
      borderRadius: 2,
      objectFit: "cover",
      background: "#F9F6EE", // cream light
      flexShrink: 0,
      mr: 1,
    },
    fileName: {
      color: "#23272F",
      fontWeight: 500,
      fontSize: 16,
      flexGrow: 1,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    menuButton: {
      color: "#757575", // Medium gray
      padding: 0,
      ml: 1,
    },
  },
  medium: {
    container: {
      p: 2,
      borderRadius: 3,
      backgroundColor: "#F9F6EE", // cream light
      color: "#212121",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.4)",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      position: "relative",
      height: 190,
      minWidth: 0,
      transition: "background 0.3s, box-shadow 0.3s",
      "&:hover": {
        backgroundColor: "#F5F7FA", // Slightly off-white
        boxShadow: "0 6px 24px rgba(100,116,139,0.13)",
      },
    },
    topBar: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1,
    },
    fileName: {
      color: "#23272F",
      fontWeight: 600,
      fontSize: "1rem",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      flex: 1,
      mr: 1,
    },
    image: {
      width: "100%",
      height: 110,
      objectFit: "cover",
      borderRadius: 6,
      background: "#F1F3F6",
      flexGrow: 1,
    },
    menuButton: {
      color: "#757575",
      p: 0.5,
      ml: 1,
    },
  },
  large: {
    container: {
      p: 2.5,
      borderRadius: 4,
      backgroundColor: "#F9F6EE",
      color: "#23272F",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.4)",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      position: "relative",
      height: 260,
      minWidth: 0,
      transition: "background 0.3s, box-shadow 0.3s",
      "&:hover": {
        backgroundColor: "#F3F6F9",
        boxShadow: "0 8px 32px rgba(100,116,139,0.15)",
      },
    },
    topBar: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1.5,
    },
    fileName: {
      color: "#23272F",
      fontWeight: 700,
      fontSize: "1.09rem",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      flex: 1,
      mr: 1,
    },
    image: {
      width: "100%",
      height: 170,
      objectFit: "cover",
      borderRadius: 8,
      background: "#F1F3F6",
      flexGrow: 1,
    },
    menuButton: {
      color: "#757575",
      p: 0.6,
      ml: 1,
    },
  },
};

export default function useViewSize(viewSize = "medium") {
  const getGridSizes = () => {
    switch (viewSize) {
      case "small":
        return { xs: 12 };
      case "medium":
        return { xs: 12, sm: 6, md: 4, lg: 2, xl: 2 }; // 6 per row at lg+
      case "large":
        return { xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }; // 12/3 = 4 per row
      default:
        return { xs: 12, sm: 6, md: 4, lg: 3 };
    }
  };

  const getStyleConfig = () => {
    return viewSizeConfig[viewSize] || viewSizeConfig.medium;
  };

  return { getGridSizes, getStyleConfig };
}
